import React, { useEffect, useState } from "react";
import { formatDate } from "../../services/helpers";
import { Admin } from "../../interfaces/admin";
import { fetchAdmins } from "../../services/adminService";
import { useAuth } from "../../auth";
import { Activity } from "../../interfaces/activity";
import { useNavigate } from "react-router-dom";
import { getRecentActivity } from "../../services/activityService";

const RecentActivity = () => {
  const navigate = useNavigate();
  const { decodeToken } = useAuth();
  const [admins, setAdmins] = useState<Admin[]>([]);
  const [selectedAdmin, setSelectedAdmin] = useState<Admin>();
  const [activity, setActivity] = useState<Activity[]>([]);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [loadingSpinner, setLoadingSpinner] = useState(false);
  const [canViewOthers, setCanViewOthers] = useState(false);

  useEffect(() => {
    const getAdminsInitial = async () => {
      try {
        setLoadingSpinner(true);
        const email = decodeToken(localStorage.getItem("token") || "");

        if (
          email.toLowerCase() === "request@oxforddoc.com" ||
          email.toLowerCase() === "amunyon@oxforddoc.com" ||
          email.toLowerCase() === "kaia_hansen@oxforddoc.onmicrosoft.com"
        ) {
          setCanViewOthers(true);
        }

        const adminsResponse = await fetchAdmins();
        setAdmins(adminsResponse);

        const found = adminsResponse.find(
          (a) => a.email.toLowerCase === email.toLowerCase,
        );
        setSelectedAdmin(found);

        if (found) {
          const activityResponse = await getRecentActivity(found.adminID);
          setActivity(activityResponse);
        }
      } catch (error) {
        console.error("Error getting admins:", error);
        setErrorMessage("Error getting admins.");
      } finally {
        setLoadingSpinner(false);
      }
    };

    getAdminsInitial();
  }, []);

  const handleAdminChange = async (e: React.ChangeEvent<HTMLSelectElement>) => {
    try {
      setErrorMessage(null);
      setLoadingSpinner(true);

      const adminID = e.target.value ? parseInt(e.target.value, 10) : 0;
      const selected = admins.find((a) => a.adminID === adminID);
      setSelectedAdmin(selected);

      const activityResponse = await getRecentActivity(adminID);
      setActivity(activityResponse);
    } catch (error) {
      console.error("Error getting activity:", error);
      setErrorMessage("Error getting activity.");
    } finally {
      setLoadingSpinner(false);
    }
  };

  return (
    <div className="content-container">
      <div className="header-container">
        <div className="page-items-container" style={{ alignItems: "center" }}>
          <h1>Recent Activity</h1>
        </div>
      </div>
      <div className="divider"></div>
      {canViewOthers && (
        <div
          className="field-long"
          style={{ width: "40%", justifySelf: "right" }}
        >
          <div style={{ display: "flex", gap: "5px" }}>
            <label className="field-label">View activity for:</label>
          </div>
          <div className="field-input">
            <select
              className="form-control"
              value={selectedAdmin?.adminID || ""}
              onChange={handleAdminChange}
            >
              <option value="">Select an Admin</option>
              {admins.map((admin) => (
                <option key={admin.adminID} value={admin.adminID}>
                  {admin.email}
                </option>
              ))}
            </select>
          </div>
        </div>
      )}
      <div className="table-wrapper">
        {errorMessage && <div className="error-message">{errorMessage}</div>}
        <div className="table-container" style={{ fontSize: "large" }}>
          <table className="table" style={{ cursor: "pointer" }}>
            <thead>
              <tr>
                <th style={{ width: "60px" }} title={"Order ID"}>
                  Order Id
                </th>
                <th style={{ width: "100px" }} title={"Modified By"}>
                  Candidate Name
                </th>
                <th style={{ width: "100px" }} title={"Viewed At"}>
                  Viewed At
                </th>
              </tr>
            </thead>
            <tbody>
              {activity?.length === 0 ? (
                <tr>
                  <td colSpan={3} style={{ textAlign: "center" }}>
                    No history found.
                  </td>
                </tr>
              ) : (
                activity?.map((row, index) => (
                  <tr
                    key={`${row.activityID}-${index}`}
                    onClick={() => navigate(`/admin/view-order/${row.orderID}`)}
                  >
                    <td
                      className="ellipsis-cell"
                      title={row.orderID.toString() ?? ""}
                    >
                      {row.orderID}
                    </td>
                    <td
                      className="ellipsis-cell"
                      title={row.candidateName ?? ""}
                    >
                      {row.candidateName}
                    </td>
                    <td>{formatDate(row.whenViewed, "datetime")}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        {loadingSpinner && (
          <div className="loading-mask">
            <div className="loading-spinner"></div>
          </div>
        )}
      </div>
    </div>
  );
};

export default RecentActivity;
